import { ChitChatsPrinterApp } from "../src/chit_chats_printer_app/chit_chats_printer_app";

window.ChitChatsPrinterApp = ChitChatsPrinterApp;
